import { capitalCase, noCase, sentenceCase } from 'change-case';

import { ValueOf } from './types';

export enum StringCase {
  Upper = 'upper',
  Lower = 'lower',
  Sentence = 'sentence',
  Capital = 'title',
  No = 'no',
}

export type StringCaseOption = StringCase | ValueOf<StringCase>;

export const asCase = <T>(
  value: T,
  casing: StringCaseOption = StringCase.Capital,
  allowNonStrings = false
) => {
  if (typeof value !== 'string') {
    if (!allowNonStrings) {
      throw new Error(
        `asCase received a non-string (${typeof value}) value for ${casing} case: ${value}`
      );
    }

    return value;
  }

  switch (casing) {
    case StringCase.Upper:
      return value.toUpperCase();
    case StringCase.Lower:
      return value.toLowerCase();
    case StringCase.No:
      return noCase(value);
    case StringCase.Capital:
      return capitalCase(value);
    case StringCase.Sentence:
      return sentenceCase(value);
    default:
      throw new Error(`Invalid casing type "${casing}" for string: ${value}`);
  }
};

asCase.StringCase = StringCase;
